import React from 'react'

import { Button } from '@wartek-id/button-v1'

import PanelKinerja from 'app/KinerjaPage/components/PanelKinerja'
import useContentContext from 'app/KinerjaPage/hooks/useContentContext'
import StickyFooter from 'app/KinerjaPage/components/StickyFooter'
import useToggleSdkContext from 'utils/useToogleSdk'

import type { Kinerja } from 'types/kinerja'

interface TabHasilKerjaTambahanProps {
  skp: Kinerja
  onClickNext?: () => void
}

const TabHasilKerjaTambahan = ({
  skp,
  onClickNext = () => {},
}: TabHasilKerjaTambahanProps) => {
  const toggles = useToggleSdkContext()
  const { getTugasTambahanById } = useContentContext()

  const isHidePointEnabled =
    toggles?.['kinerja-hide-rhk-point-enabled'] === true
  const isNewFlow = isHidePointEnabled && skp.tahun > 2024

  return (
    <>
      <div className="p-9">
        <div className="flex flex-col gap-9">
          {skp.tugasTambahan.map(({ id }, i) => {
            const tugasTambahan = getTugasTambahanById(id)

            return (
              <PanelKinerja
                key={`tugasTambahan-${i}`}
                data-testid={`tugasTambahan-${i}`}
                number={i + 1}
                kinerja={tugasTambahan}
                showDetails={!isNewFlow}
              />
            )
          })}
        </div>
      </div>

      <StickyFooter>
        <Button
          size="lg"
          color="black"
          onClick={() => onClickNext()}
          type="button"
          data-testid="btn-next"
        >
          Ke Perilaku Kerja
        </Button>
      </StickyFooter>
    </>
  )
}

export default TabHasilKerjaTambahan
